export default {
    pageSize: 10,
    pageNumber: 1,
    maxPageSize: 1000000
};
